import {
    mdiEyeCircleOutline,
} from '@mdi/js'


export default [
  {
    subheader: 'Eye(Flow/Tracking)',
    resource: 'oculis',
    action: 'read'
  },
  {
    title: 'Oculis',
    icon: mdiEyeCircleOutline,
    to: 'oculis-list',
    resource: 'oculis',
    action: 'read'
  },
]